import { handleActions } from 'redux-actions';

import { createSelector } from '@reduxjs/toolkit';
import {
  createLoadByIdReducer,
  createLoadListReducerWithBegin,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import {

  CREATE_INTERVAL,
  DELETE_INTERVAL,
  EDIT_INTERVAL,
  LOAD_CURRENT_INTERVAL_BY_ID,
  LOAD_INTERVAL_LIST,

  CREATE_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
  EDIT_SUBSCRIPTION,
  LOAD_SUBSCRIPTION_BY_ID,
  LOAD_SUBSCRIPTION_LIST,

  CREATE_SUBSCRIPTION_TYPE,
  DELETE_SUBSCRIPTION_TYPE,
  EDIT_SUBSCRIPTION_TYPE,
  LOAD_SUBSCRIPTION_TYPE_BY_ID,
  LOAD_SUBSCRIPTION_TYPE_LIST,
  LOAD_BLACK_LIST,
  LOAD_CURRENT_BLACK_WHITES_BY_ID,
  LOAD_WHITES_LIST,
  CREATE_BLACK_WHITES,
  EDIT_BLACK_WHITES,
  DELETE_BLACK_WHITES,
  SET_BLACK_WHITES_MODULE_STATUS,
} from './actions';
import { SUBSCRIPTION_MODULE } from '../../configs/moduleNames';

const initialState = {
  subscriptionList: [],
  subscriptionListMeta: {},
  loadingSubscriptionList: false,
  currentSubscription: null,
  loadingCurrentSubscription: false,
  loadingCreateSubscription: false,
  loadingEditSubscription: false,
  loadingDeleteSubscription: false,
  currentInterval: null,
  loadingCurrentInterval: false,
  intervalList: [],
  intervalListMeta: {},
  loadingIntervalList: false,
  loadingCreateInterval: false,
  loadingEditInterval: false,
  loadingDeleteInterval: false,

  subscriptionTypeList: [],
  subscriptionTypeListMeta: {},
  loadingSubscriptionTypeList: false,
  currentSubscriptionType: null,
  loadingCurrentSubscriptionType: false,
  loadingCreateSubscriptionType: false,
  loadingEditSubscriptionType: false,
  loadingDeleteSubscriptionType: false,

  whitesList: [],
  whitesListMeta: {},
  loadingWhitesList: false,
  blackList: [],
  blackListMeta: {},
  loadingBlackList: false,
  currentBlackWhites: null,
  loadingCurrentBlackWhites: false,
  loadingCreateBlackWhites: false,
  loadingEditBlackWhites: false,
  loadingDeleteBlackWhites: false,
  blackWhitesModuleAvailable: true,
  blackWhitesModuleChecked: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_LIST, 'subscriptionList', 'loadingSubscriptionList'),
  ...createLoadByIdReducer(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_BY_ID, 'currentSubscription', 'loadingCurrentSubscription'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION, 'loadingCreateSubscription'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION, 'loadingEditSubscription'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION, 'loadingDeleteSubscription'),
  ...createLoadListReducerWithBegin(SUBSCRIPTION_MODULE + LOAD_INTERVAL_LIST, 'intervalList', 'loadingIntervalList'),
  ...createLoadByIdReducer(SUBSCRIPTION_MODULE + LOAD_CURRENT_INTERVAL_BY_ID, 'currentInterval', 'loadingCurrentInterval'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + CREATE_INTERVAL, 'loadingCreateInterval'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + EDIT_INTERVAL, 'loadingEditInterval'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + DELETE_INTERVAL, 'loadingDeleteInterval'),

  ...createLoadListReducerWithBegin(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_LIST, 'subscriptionTypeList', 'loadingSubscriptionTypeList'),
  ...createLoadByIdReducer(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_BY_ID, 'currentSubscriptionType', 'loadingCurrentSubscriptionType'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION_TYPE, 'loadingCreateSubscriptionType'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION_TYPE, 'loadingEditSubscriptionType'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION_TYPE, 'loadingDeleteSubscriptionType'),

  ...createLoadListReducerWithBegin(SUBSCRIPTION_MODULE + LOAD_WHITES_LIST, 'whitesList', 'loadingWhitesList'),
  ...createLoadListReducerWithBegin(SUBSCRIPTION_MODULE + LOAD_BLACK_LIST, 'blackList', 'loadingBlackList'),
  ...createLoadByIdReducer(SUBSCRIPTION_MODULE + LOAD_CURRENT_BLACK_WHITES_BY_ID, 'currentBlackWhites', 'loadingCurrentBlackWhites'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + CREATE_BLACK_WHITES, 'loadingCreateBlackWhites'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + EDIT_BLACK_WHITES, 'loadingEditBlackWhites'),
  ...createOperationStateReducer(SUBSCRIPTION_MODULE + DELETE_BLACK_WHITES, 'loadingDeleteBlackWhites'),

  [SUBSCRIPTION_MODULE + SET_BLACK_WHITES_MODULE_STATUS]: (state, action) => {
    const { payload = {} } = action;

    return {
      ...state,
      blackWhitesModuleAvailable: typeof payload.available === 'boolean'
        ? payload.available
        : state.blackWhitesModuleAvailable,
      blackWhitesModuleChecked: typeof payload.checked === 'boolean'
        ? payload.checked
        : true,
    };
  },
}, initialState);

export default reducer;

export const getSubscriptionData = createSelector(
  [state => state[SUBSCRIPTION_MODULE]],
  state => {
    const {
      subscriptionList,
      subscriptionListMeta,
      loadingSubscriptionList,
      currentSubscription,
      loadingCurrentSubscription,
      loadingCreateSubscription,
      loadingEditSubscription,
      loadingDeleteSubscription,
      currentInterval,
      loadingCurrentInterval,
      intervalList,
      intervalListMeta,
      loadingIntervalList,
      loadingCreateInterval,
      loadingEditInterval,
      loadingDeleteInterval,

      subscriptionTypeList,
      subscriptionTypeListMeta,
      loadingSubscriptionTypeList,
      currentSubscriptionType,
      loadingCurrentSubscriptionType,
      loadingCreateSubscriptionType,
      loadingEditSubscriptionType,
      loadingDeleteSubscriptionType,

      whitesList,
      whitesListMeta,
      loadingWhitesList,
      blackList,
      blackListMeta,
      loadingBlackList,
      currentBlackWhites,
      loadingCurrentBlackWhites,
      loadingCreateBlackWhites,
      loadingEditBlackWhites,
      loadingDeleteBlackWhites,
      blackWhitesModuleAvailable,
      blackWhitesModuleChecked,
    } = state;

    return {
      subscriptionList,
      subscriptionListMeta,
      loadingSubscriptionList,
      currentSubscription,
      loadingCurrentSubscription,
      currentInterval,
      loadingCurrentInterval,
      loadingCreateSubscription,
      loadingEditSubscription,
      loadingDeleteSubscription,
      intervalList,
      intervalListMeta,
      loadingIntervalList,
      loadingCreateInterval,
      loadingEditInterval,
      loadingDeleteInterval,

      subscriptionTypeList,
      subscriptionTypeListMeta,
      loadingSubscriptionTypeList,
      currentSubscriptionType,
      loadingCurrentSubscriptionType,
      loadingCreateSubscriptionType,
      loadingEditSubscriptionType,
      loadingDeleteSubscriptionType,

      whitesList,
      whitesListMeta,
      loadingWhitesList,
      blackList,
      blackListMeta,
      loadingBlackList,
      currentBlackWhites,
      loadingCurrentBlackWhites,
      loadingCreateBlackWhites,
      loadingEditBlackWhites,
      loadingDeleteBlackWhites,
      blackWhitesModuleAvailable,
      blackWhitesModuleChecked,
    };
  },
);
